// @flow
import * as React from "react";
import cx from "classnames";
import styles from "./PageHeader.scss";
import type { ReactElementRef } from "../../types/react";

type PageHeaderProps = {
  header: string,
  subheader?: string,
  className?: string,
  isBoldHeader: boolean,
  isSmallSubheader: boolean,
  bottomMargin: boolean,
  isSubheaderCapped: boolean,
  isCentered: boolean,
  customHeaderStyles?: string,
  children: React.Node
};

class PageHeader extends React.Component<PageHeaderProps> {
  static defaultProps = {
    isBoldHeader: false,
    isSmallSubheader: false,
    isSubheaderCapped: false,
    isCentered: false,
    bottomMargin: false
  };

  headerRef: ReactElementRef<HTMLHeadingElement> = React.createRef();

  subheaderRef: ReactElementRef<HTMLParagraphElement> = React.createRef();

  componentDidMount() {
    this.setSubheaderWidth();

    window.addEventListener("resize", this.setSubheaderWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setSubheaderWidth);
  }

  setSubheaderWidth = () => {
    const { isSubheaderCapped } = this.props;
    const subheaderElement = this.subheaderRef.current;

    if (isSubheaderCapped && subheaderElement && this.headerRef.current) {
      const headerWidth = this.headerRef.current.offsetWidth;

      subheaderElement.style.maxWidth = `${headerWidth}px`;
    }
  };

  render() {
    const {
      header,
      subheader,
      isBoldHeader,
      isSmallSubheader,
      className,
      bottomMargin,
      isCentered,
      customHeaderStyles,
      children
    } = this.props;

    return (
      <div
        className={cx(
          styles.wrapper,
          {
            [styles.margin]: bottomMargin,
            [styles.centeredWrapper]: isCentered
          },
          className
        )}
      >
        <div>
          <h1
            ref={this.headerRef}
            className={cx({ [styles.boldHeader]: isBoldHeader }, styles.header, customHeaderStyles)}
          >
            {header}
          </h1>
          {subheader && (
            <p
              ref={this.subheaderRef}
              className={cx({ [styles.smallSubheader]: isSmallSubheader }, styles.subHeader)}
            >
              {subheader}
            </p>
          )}
        </div>
        {children && <div>{children}</div>}
      </div>
    );
  }
}

export default PageHeader;
